/****************************************
	Tab
*****************************************/
;(function ($) {
	'use strict';
	var shared = {
			'debounce': function (callback, delay, immediate) {
				return this.throttle(callback, delay, undefined, !!immediate);
			},
			'throttle': function (callback, delay, noTrail, immediate) {
				var timeout,
					previous = 0,
					result = function () {
						var self = this,
							elapsed = Date.now() - previous,
							args = arguments,
							timeoutCallback,
							timeoutDelay;
						function reset() {
							timeout = undefined;
						}
						function execute() {
							previous = Date.now();
							callback.apply(self, args);
						}
						if (immediate && !timeout) {
							execute();
						}
						if (timeout) {
							clearTimeout(timeout);
						}
						if (immediate === undefined && elapsed > delay) {
							execute();
						} else if (noTrail !== true) {
							timeoutCallback = immediate ? reset : execute;
							timeoutDelay = immediate === undefined ? delay - elapsed : delay;
							timeout = setTimeout(timeoutCallback, timeoutDelay);
						}
					};
				return result;
			},
			'warn': function (msg, useAlert) {
				if (window.console) {
					console.warn(msg);
					if (useAlert && /ancestry(?:stage|dev)/.test(window.location.hostname)) {
						alert(msg);
					}
				}
			}
		},
		tabs = {
			'create': function ($element, options) {
				var instance = $element.data('tabsInstance'),
					resizeEvent;
				if (instance) {
					instance.destroy();
				}
				if ($element.data('allow-urls') === true) {
					options = options || {};
					options.allowUrls = true;
				}
				instance = Object.create(this.proto);
				instance.config = $.extend({}, this.staticProperties.defaults, options);
				instance.$element = $element;
				/* Instance state data */
				instance.tabsName = $element.data('tab');
				instance.isVertical = instance._getVertical();
				instance.activeIndex = instance._getActiveIndex();
				instance.overflowBound = false;
				/* Instance elements */
				instance.$tabs = $element.children('.tab');
				instance.$tabGroup = $('[data-tab-group="' + instance.tabsName + '"]');
				instance.$tabContents = instance.$tabGroup.children('.tabContent');
				instance.$tabContents.attr('tabindex', '-1');
				/* Add events */
				resizeEvent = ('ontouchstart' in window || (window.DocumentTouch && document instanceof DocumentTouch)) ? 'orientationchange.tabs' : 'resize.tabs'; /* iOS triggers extra resize events so only trigger on orientation change on touch devices */
				resizeEvent += '.' + instance.tabsName;
				$(window).on(resizeEvent, shared.debounce(function () {
					return instance._handleResize();
				}, 100));
				instance.$element.on('click.tabs', '.tab', function (e) {
					return instance._handleTabClick(e);
				});
				instance.$element.on('keydown.tabs', '.tab', function (e) {
					return instance._handleTabKeydown(e);
				});
				/* Initialization methods */
				instance._applyAriaRoles();
				instance._updateTabs();
				instance._removeButtonClasses();
				instance._updateButtonClasses();
				instance._triggerClickOnUrlTab();
				/* Wait 500ms before checking for overflow to ensure styles have loaded */
				instance.delayedCheckOverflow = setTimeout(function () {
					if (typeof instance.overflow === 'undefined') {
						instance._measureWidths();
						instance._checkOverflow();
					}
				}, 500);
				instance.$element.data('tabsInstance', instance);
				return instance;
			},
			'proto': {
				'_addOverflow': function () {
					this._createOverflowElements();
					this._bindOverflowEvents();
					this._measureWidths();
					this._centerTab();
				},
				'_animateHorizontalScroll': function (direction) {
					var dx = Math.ceil(this.elementWidth * 0.75),
						dt = 250,
						xi = this.$element.scrollLeft(),
						xf = direction === 'left' ? xi - dx : xi + dx;
					this.$element.animate({scrollLeft: xf}, dt);
				},
				'_applyAriaRoles': function () {
					var self = this;
					this.$element.attr('role', this.$element.attr('role') || 'tablist');
					this.$tabs.each(function (i) {
						var $tab = $(this),
							dataTab = self.tabsName || 'Tabs' + Date.now() + Math.floor((Math.random() * 1000) + 1),
							isTabActive = $tab.hasClass('tabActive'),
							$curTabPanel = self.$tabContents.eq(i),
							panelId = $curTabPanel.attr('id') || dataTab + 'TabPanel' + i;
						$tab.attr({
							'id': $tab.attr('id') || self.tabsName + 'Tab' + i,
							'role': $tab.attr('role') || 'tab',
							'aria-controls': $tab.attr('aria-controls') || panelId,
							'aria-selected': $tab.attr('aria-selected') || isTabActive,
							'aria-expanded': isTabActive
						});
						$curTabPanel.attr({
							'id': panelId,
							'role': $curTabPanel.attr('role') || 'tabpanel',
							'aria-labelledby': $curTabPanel.attr('aria-labelledby') || $tab.attr('id'),
							'aria-hidden': !isTabActive
						});
					});
				},
				'_bindOverflowEvents': function () {
					var self = this;
					this.$element.on('scroll.tabs', shared.throttle(function () {
						return self._handleOverflowScroll();
					}, 100));
					this.$overflowLeftButton.on('click.tabs', shared.debounce(function () {
						self._animateHorizontalScroll('left');
						return true;
					}, 250, true));
					this.$overflowRightButton.on('click.tabs', shared.debounce(function () {
						self._animateHorizontalScroll('right');
						return true;
					}, 250, true));
					this.overflowBound = true;
				},
				'_centerTab': function () {
					if (this.overflow) {
						var $tab = this.$tabs.eq(this.activeIndex),
							w = $tab.outerWidth(false),
							offX = $tab.position().left,
							curX = this.$element.scrollLeft(),
							pLeft = parseInt(this.$element.css('padding-left'), 10),
							mLeft = parseInt($tab.css('margin-left'), 10),
							ideal = (this.elementWidth - w) / 2;
						this.$element.animate({scrollLeft: curX + offX - pLeft + mLeft - ideal}, 250);
					}
				},
				'_checkOverflow': function () {
					this.overflow = this._getOverflow();
					if (this.overflow) {
						if (!this.overflowBound) {
							this._addOverflow();
						}
						this._handleOverflowScroll();
					} else if (this.overflowBound) {
						this._removeOverflow();
					}
				},
				'_checkSubTabs': function () {
					var $tabContent = this.$tabContents.eq(this.activeIndex),
						$subTabs = $tabContent.find('.tabs');
					if ($subTabs.length) {
						$subTabs.each(function () {
							var $subTab = $(this);
							if ($subTab.data('tabsInstance')) {
								$subTab.tabs('resize');
							} else if ($subTab.data('auto-instantiate') !== 'off') {
								$subTab.tabs();
							}
						});
					}
				},
				'_clearActiveTab': function () {
					this.$tabs
						.removeClass('tabActive active tabLast tabFirst')
						.attr({
							'aria-selected': 'false',
							'aria-expanded': 'false'
						});
					this.$tabContents
						.removeClass('tabActive active')
						.attr('aria-hidden', 'true');
				},
				'_createOverflowElements': function () {
					var hasVerticalTabs = this.$element.hasClass('tabsVertical') ? ' hasVerticalTabs' : '';
					this.$element.wrap('<div class="tabsScrollable' + hasVerticalTabs + '" />');
					this.$overflow = this.$element.parent();
					this.$overflowLeftButton = $('<button class="icon iconArrowLeft tabsOverflowBtn" aria-hidden="true" tabindex="-1" type="button" />');
					this.$overflowRightButton = $('<button class="icon iconArrowRight tabsOverflowBtn" aria-hidden="true" tabindex="-1" type="button" />');
					this.$overflowLeftButton.insertBefore(this.$overflow);
					this.$overflowRightButton.insertAfter(this.$overflow);
				},
				'destroy': function () {
					clearTimeout(this.delayedCheckOverflow);
					this._removeOverflow();
					this.$element.off('.tabs');
					this._removeAriaRoles();
					$(window).off('.tabs.' + this.tabsName);
					this.$element.removeData('tabsInstance'); /* Remove instance data from $element. */
				},
				'_getActiveIndex': function () {
					var config = this.config,
						activeIndex,
						tabActive;
					if (config.activeIndex) {
						activeIndex = config.activeIndex;
					} else if (config.active) {
						activeIndex = config.active - 1;
					} else {
						tabActive = this.$element.find('.tabActive');
						activeIndex = tabActive.length ? tabActive.index() : 0;
					}
					return activeIndex;
				},
				/* Calculate the available width of $element. */
				'_getElementWidth': function () {
					var outerWidth = this.$element.outerWidth(false),
						paddingLeft = parseInt(this.$element.css('padding-left'), 10),
						paddingRight = parseInt(this.$element.css('padding-right'), 10);
					return Math.max(0, outerWidth - (paddingLeft + paddingRight));
				},
				/* Check if tabs are wider than their container. */
				'_getOverflow': function () {
					/* Don't bother with vertical tabs. */
					if (this.isVertical || this.$element.is(':hidden') || this.config.overrideOverflow) {
						return false;
					}
					return this.tabsWidth > this.elementWidth;
				},
				/* Calculate the cumulative width of the tab elements. */
				'_getTabsWidth': function () {
					var totalWidth = 0;
					this.$tabs.each(function () {
						totalWidth += $(this).outerWidth(true);
					});
					return totalWidth;
				},
				'_getVertical': function () {
					var windowWidth = $(window).width(),
						notResponsive = !this.$element.hasClass('tabs480') && !this.$element.hasClass('tabs320'),
						responsiveOnTablet = this.$element.hasClass('tabs480') && (windowWidth >= 768),
						responsiveOnMobile = this.$element.hasClass('tabs320') && (windowWidth >= 480);
					return (this.$element.hasClass('tabsVertical') && (notResponsive || responsiveOnTablet || responsiveOnMobile));
				},
				'_handleOverflowScroll': function () {
					var leftX = this.$element.scrollLeft();
					if (this.$overflow) {
						/* Check for overflow on the right. */
						if (leftX < this.tabsWidth - this.elementWidth - 5) {
							this.$overflow.addClass('tabsOverflowRight');
							this.$overflowRightButton.addClass('tabsOverflowBtnVisible');
						} else {
							this.$overflow.removeClass('tabsOverflowRight');
							this.$overflowRightButton.removeClass('tabsOverflowBtnVisible');
						}
						/* Check for overflow on the left. */
						if (leftX > 5) {
							this.$overflow.addClass('tabsOverflowLeft');
							this.$overflowLeftButton.addClass('tabsOverflowBtnVisible');
						} else {
							this.$overflow.removeClass('tabsOverflowLeft');
							this.$overflowLeftButton.removeClass('tabsOverflowBtnVisible');
						}
					}
					return true;
				},
				'_handleResize': function () {
					this.isVertical = this._getVertical();
					this._updateButtonClasses();
					this._measureWidths();
					this._checkOverflow();
					return true;
				},
				'_handleTabClick': function (e) {
					var config = this.config,
						$tab = $(e.currentTarget),
						thisHref = $tab.attr('href');
					/* Do not run if already the active tab */
					if ($tab.index() === this.activeIndex) {
						return false;
					}
					/* If the tab is supposed to go to a new page, exit here */
					if (!config.allowUrls && thisHref && thisHref.indexOf('#') !== 0 && thisHref.indexOf('javascript') !== 0) {
						window.location = thisHref;
						return false; /* Just in case so window doesn't redirect twice */
					}
					this.activeIndex = $tab.index();
					this._updateTabs();
					if (config.allowUrls) {
						return false;
					}
					return true;
				},
				'_handleTabKeydown': function (e) {
					/* Keyboard accessibility, left/right arrow keys alternates tab focus, space activates tab giving focus to tabpanel (.tabContent) */
					var $tab = $(e.currentTarget),
						key = e.which;
					if (key === 37) {
						/* left arrow */
						$tab.prev().focus();
					} else if (key === 39) {
						/* right arrow */
						$tab.next().focus();
					}
					return true;
				},
				'_measureWidths': function () {
					this.tabsWidth = this._getTabsWidth();
					this.elementWidth = this._getElementWidth();
				},
				'_removeAriaRoles': function () {
					this.$element.removeAttr('role');
					this.$tabs.removeAttr('role aria-controls aria-selected aria-expanded');
					this.$tabContents.removeAttr('role aria-labelledby aria-hidden');
				},
				'_removeButtonClasses': function () {
					if (this.$tabs.hasClass('ancBtnL')) {
						this.$element.addClass('tabsConnected');
					}
					if (this.$tabs.hasClass('ancBtn')) {
						shared.warn('The ancBtn class should not be used on tabs.');
					}
					this.$tabs.removeClass('ancBtn ancBtnL ancBtnM ancBtnR silver');
				},
				'_removeOverflow': function () {
					if (this.$overflow && this.$overflow.hasClass('tabsScrollable')) {
						this.$element.unwrap();
						this.$overflowLeftButton.remove();
						this.$overflowRightButton.remove();
						this.$overflow = false;
						this.$overflowLeftButton = false;
						this.$overflowRightButton = false;
						this._measureWidths();
					}
					this._removeOverflowEvents();
				},
				'_removeOverflowEvents': function () {
					this.$element.off('scroll.tabs');
					this.overflowBound = false;
				},
				'resize': function () {
					this._handleResize();
				},
				'_setActiveContent': function () {
					var config = this.config;
					this.$tabContents.eq(this.activeIndex)
						.addClass('tabActive active')
						.attr('aria-hidden', 'false');
					if (config.onOpen && $.isFunction(config.onOpen)) {
						config.onOpen.apply(this.$element, [this.activeIndex, this.$tabContents.eq(this.activeIndex)]);
					}
					this._checkSubTabs();
				},
				'_setActiveTab': function () {
					this.$tabs.eq(this.activeIndex)
						.addClass('tabActive active')
						.attr({
							'aria-selected': 'true',
							'aria-expanded': 'true'
						});
				},
				'_triggerClickOnUrlTab': function () {
					var self = this,
						config = this.config;
					if (config && (!isNaN(parseInt(config.active, 10)) || !isNaN(parseInt(config.activeIndex, 10)))) {
						/* Only run activated tab if hash does not match another tab */
						if (!window.location.hash || !$('.tab[data-label="' + window.location.hash.replace('#', '') + '"], .tab[href="' + window.location.hash + '"]').length) {
							/* Run after all tabs initialized with setTimeout */
							setTimeout(function () {
								self.$tabs.eq(self.activeIndex).trigger('click.tabs');
							}, 100);
						}
					}
				},
				'_updateButtonClasses': function () {
					if (this.$element.hasClass('tabsVertical')) {
						if (this.isVertical) {
							this.$element.removeClass('tabsConnected');
						} else {
							this.$element.addClass('tabsConnected');
						}
					}
				},
				'_updateTabs': function () {
					this._clearActiveTab();
					this._setActiveTab();
					this._setActiveContent();
					this._centerTab();
				}
			},
			'staticProperties': {
				'defaults': {
					'active': false,
					'activeIndex': false,
					'allowUrls': false,
					'onOpen': false, /* function (tabIndex, $tabContent) {} */
					'overrideOverflow': false
				}
			}
		},
		version = 2,
		doubleIncluded = !!$.tabs;
	if (doubleIncluded) {
		if ($.tabs.version === version) {
			shared.warn('ERROR: You are including tab.js multiple times');
			return;
		} else {
			shared.warn('ERROR: You are including multiple versions of tab.js');
			if ($.tabs.version > version) {
				return;
			}
		}
	}
	/* Plugin definition */
	$.fn.tabs = function (options) {
		var isMethodCall = typeof options === 'string', /* If options is a string, we assume it refers to a method. */
			args = arguments,
			returnValue = this;
		this.each(function () {
			var $this = $(this),
				instance = $this.data('tabsInstance'),
				methodValue;
			if (isMethodCall) {
				if (!instance) {
					shared.warn('Cannot call methods on tabs prior to initialization; attempted to call method "' + options + '".');
					return false;
				}
				if (!$.isFunction(instance[options]) || options.indexOf('_') === 0) {
					shared.warn('No such method "' + options + '" for tabs.');
					return false;
				}
				methodValue = instance[options].apply(instance, Array.prototype.slice.call(args, 1));
				if (methodValue !== instance && methodValue !== undefined) {
					returnValue = methodValue && methodValue.jquery ? returnValue.pushStack(methodValue.get()) : methodValue;
					return false;
				}
			} else {
				tabs.create($this, options);
			}
		});
		return returnValue;
	};
	/* Expose testable methods */
	$.tabs = {
		'getTest': function () {
			return $.extend({}, tabs);
		},
		'version': version
	};
	if (!doubleIncluded) {
		/* Auto-instantiation */
		$(function () {
			/* .tabs2 is deprecated @TODO: Remove in December; */
			$('.tabs, .tabs2')
				.filter(function () {
					/* Prevent double instantiation and auto-instantiation when it is turned off. */
					return !$(this).data('tabsInstance') && $(this).data('auto-instantiate') !== 'off';
				})
				.tabs();
			if (window.location.hash) {
				$('.tab[data-label="' + window.location.hash.replace('#', '') + '"], .tab[href="' + window.location.hash + '"]').trigger('click.tabs'); /* Auto open url tab */
			}
		});
	}
}(jQuery));